import ReactMarkdown from "react-markdown";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

/**
 * LegalPage — reusable minimally-animated wrapper for legal documents.
 * Renders exact markdown content with typographic styling that matches the site.
 */
export default function LegalPage({ content, testId }) {
  return (
    <div className="bg-bone min-h-screen" data-testid={testId}>
      <Navbar />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <article className="legal-content text-ink">
          <ReactMarkdown
            components={{
              h1: (p) => <h1 className="font-serif text-4xl md:text-5xl font-light tracking-tighter leading-tight text-forest mb-6" {...p} />,
              h2: (p) => <h2 className="font-serif text-2xl md:text-3xl font-medium text-forest mt-12 mb-3 tracking-tight" {...p} />,
              h3: (p) => <h3 className="font-serif text-xl md:text-2xl font-medium text-ink mt-8 mb-2" {...p} />,
              p:  (p) => <p className="text-ink/80 leading-relaxed my-4" {...p} />,
              strong: (p) => <strong className="text-ink font-semibold" {...p} />,
              blockquote: (p) => (
                <blockquote className="my-6 border-l-4 border-terracotta bg-bonewarm rounded-r-lg px-5 py-4 text-ink/75 text-sm md:text-base italic" {...p} />
              ),
              a: (p) => <a className="text-forest underline underline-offset-4 decoration-forest/40 hover:decoration-forest break-words" {...p} />,
              ul: (p) => <ul className="list-disc list-outside pl-6 my-4 space-y-1 text-ink/80" {...p} />,
              ol: (p) => <ol className="list-decimal list-outside pl-6 my-4 space-y-1 text-ink/80" {...p} />,
              li: (p) => <li className="leading-relaxed" {...p} />,
              hr: () => <hr className="my-10 border-[#E2DFD8]" />,
            }}
          >
            {content}
          </ReactMarkdown>
        </article>
      </main>
      <Footer />
    </div>
  );
}
